/** TODO: to be refactored using "utils()" like dates */
hrd.config.timepicker = {
	timeFormat: 'HH:mm',
	stepHour: 1,
	stepMinute: 5, //richiesto da Boss - rispostato a 5 (da rendere configurabile)
	hourGrid: 2,
	minuteGrid: 10,
	hourMin: function(){
		var t = (hrd.globals.prefs.node.openTime) ? hrd.globals.prefs.node.openTime : '00:00';
		return parseInt(t.substring(0, 2));
	}(),
	hourMax: function(){
		var t = (hrd.globals.prefs.node.closeTime) ? hrd.globals.prefs.node.closeTime : '23:00';
		return parseInt(t.substring(0, 2));
	}()
};
